var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXapplogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 178.8 35.7",
    style: {
      enableBackground: "new 0 0 178.8 35.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0B9FB1;}\n\t.st1{fill:none;stroke:#0B9FB1;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    transform: "translate(-44.522 -18.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    transform: "translate(44.522 18.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    className: "st0",
    d: "M12.1,13.4c0.2,0.3,0.3,0.6,0.3,1c-0.1,0.4-0.3,0.7-0.6,0.9c-0.3,0.2-0.6,0.3-0.9,0.3 c-0.4,0-0.7-0.2-0.9-0.6L0.3,2.3C0.1,2.1,0,1.7,0,1.4c0-0.4,0.2-0.7,0.6-0.9c0.3-0.2,0.6-0.3,0.9-0.3c0.3,0,0.7,0.2,0.9,0.5 L12.1,13.4z M2.7,35.1c-0.5,0.6-1.3,0.7-1.9,0.2c-0.3-0.2-0.4-0.5-0.5-0.8c-0.1-0.3,0-0.7,0.2-1l12.2-16.5h0.1L25,0.5 c0.2-0.3,0.5-0.4,0.9-0.5c0.4-0.1,0.7,0,1,0.3c0.3,0.2,0.5,0.5,0.5,0.9c0.1,0.3,0,0.7-0.3,1L15.4,17.9l12,15.6 c0.2,0.3,0.3,0.6,0.3,0.9c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.6,0.3-1,0.3c-0.4-0.1-0.7-0.3-0.9-0.6L13.8,20.1L2.7,35.1z"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    className: "st1",
    x1: 17,
    y1: 30.1,
    x2: 10.9,
    y2: 30.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    transform: "translate(93.574 27.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    className: "st0",
    d: "M0.5-0.1c0.2,0,0.4,0.1,0.5,0.2c0.2,0.3,0.2,0.7,0,0.9C0.8,1.1,0.6,1.2,0.5,1.2h-4.6v15.9 c0,0.4-0.3,0.6-0.7,0.7c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5V1.2H-10c-0.4,0-0.7-0.3-0.6-0.7c0-0.3,0.3-0.6,0.6-0.6 H0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    className: "st0",
    d: "M5.3,0.5c0-0.4,0.3-0.6,0.7-0.7c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5v16.6 c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2c-0.4,0-0.6-0.3-0.7-0.7V0.5z M17.6,0.5c0-0.2,0.1-0.3,0.2-0.5 c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5v16.6c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2 c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3-0.2-0.5V9.5H8.1c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h9.5V0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    className: "st0",
    d: "M24.1,17.8c-0.4,0-0.6-0.3-0.7-0.7V0.5c0-0.4,0.3-0.6,0.7-0.7h10.8c0.2,0,0.3,0.1,0.4,0.2 c0.2,0.3,0.2,0.7,0,0.9c-0.1,0.1-0.3,0.2-0.4,0.2H24.8v15.3h10c0.3,0,0.6,0.2,0.7,0.6c0,0,0,0,0,0.1c0,0.2-0.1,0.3-0.2,0.5 c-0.1,0.1-0.3,0.2-0.5,0.2L24.1,17.8z M26.1,9.5c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7H31c0.4,0,0.7,0.3,0.7,0.7 S31.4,9.5,31,9.5l0,0H26.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    className: "st0",
    d: "M60.4,0.1c0.2-0.3,0.7-0.3,1-0.1c0.1,0.1,0.2,0.2,0.2,0.4c0,0.2,0,0.3-0.1,0.5l-6.2,8.3h0 L49,17.5c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0-0.4,0-0.5-0.1c-0.1-0.1-0.2-0.3-0.3-0.4c0-0.2,0-0.4,0.1-0.5l6-7.9l-6-7.9 c-0.1-0.1-0.2-0.3-0.1-0.5c0-0.2,0.1-0.3,0.3-0.4c0.1-0.1,0.3-0.2,0.5-0.1c0.2,0,0.3,0.1,0.4,0.3l5.7,7.6L60.4,0.1z M55.5,11.1 c-0.1-0.1-0.1-0.3-0.1-0.5c0-0.2,0.1-0.3,0.3-0.4C55.8,10,56,10,56.1,10c0.2,0,0.3,0.1,0.4,0.3l4.9,6.4c0.1,0.1,0.2,0.3,0.1,0.5 c0,0.2-0.1,0.3-0.3,0.4c-0.1,0.1-0.3,0.2-0.5,0.1c-0.2,0-0.3-0.1-0.4-0.3L55.5,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    className: "st0",
    d: "M78.8,0.3c0.1-0.3,0.3-0.5,0.6-0.5s0.5,0.2,0.6,0.5l6.7,16.6c0.1,0.2,0.1,0.3,0,0.5 c-0.1,0.2-0.2,0.3-0.4,0.3c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.3-0.2-0.3-0.4L79.5,2.3l-6.1,15.1c-0.1,0.2-0.2,0.3-0.3,0.4 c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.3-0.2-0.4-0.3c-0.1-0.2-0.1-0.3,0-0.5L78.8,0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    className: "st0",
    d: "M90.8,17.6c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5V0.5 c0-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h6.9c0.7,0,1.4,0.1,2.1,0.4c0.6,0.3,1.2,0.7,1.7,1.2c0.5,0.5,0.9,1,1.1,1.7 c0.3,0.6,0.4,1.3,0.4,2c0,1.4-0.5,2.8-1.5,3.8c-0.4,0.4-1,0.8-1.5,1.1c-0.6,0.3-1.2,0.4-1.9,0.4c0,0-0.1,0.1-0.1,0h-5 c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.4-0.2h4.8c0.5,0,1.1-0.1,1.5-0.3 c0.5-0.2,0.9-0.5,1.3-0.9c0.4-0.4,0.6-0.8,0.8-1.3c0.2-0.5,0.3-1,0.3-1.6c0-0.5-0.1-1.1-0.3-1.5c-0.2-0.5-0.5-0.9-0.8-1.2 c-0.4-0.4-0.8-0.7-1.3-0.9c-0.5-0.2-1-0.3-1.5-0.3H91v16C91,17.3,90.9,17.4,90.8,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    className: "st0",
    d: "M107.3,17.6c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5V0.5 c0-0.2,0.1-0.3,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h6.9c0.7,0,1.4,0.1,2.1,0.4c0.6,0.3,1.2,0.7,1.7,1.2c0.5,0.5,0.9,1,1.1,1.7 c0.3,0.6,0.4,1.3,0.4,2c0,1.4-0.5,2.8-1.5,3.8c-0.4,0.4-1,0.8-1.5,1.1c-0.6,0.3-1.2,0.4-1.9,0.4c0,0-0.1,0.1-0.1,0h-5 c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.4-0.2h4.8c0.5,0,1.1-0.1,1.5-0.3 c0.5-0.2,0.9-0.5,1.3-0.9c0.4-0.4,0.6-0.8,0.8-1.3c0.2-0.5,0.3-1,0.3-1.6c0-0.5-0.1-1.1-0.3-1.5c-0.2-0.5-0.5-0.9-0.8-1.2 c-0.4-0.4-0.8-0.7-1.3-0.9c-0.5-0.2-1-0.3-1.5-0.3h-6.2v16C107.5,17.3,107.5,17.4,107.3,17.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXapplogo);
export default __webpack_public_path__ + "static/media/xapplogo.e5419e69df88ecd533f12ac747a238bf.svg";
export { ForwardRef as ReactComponent };